/**
 * Shared helpers that keep <title> and <meta name="description"> inside the
 * lengths search engines actually render, without cutting mid-word.
 */

export const MAX_TITLE = 60;
export const MAX_DESCRIPTION = 155;

function clampAtWord(text: string, max: number): string {
  const clean = text.replace(/\s+/g, " ").trim();
  if (clean.length <= max) return clean;
  const cut = clean.slice(0, max - 1);
  const lastSpace = cut.lastIndexOf(" ");
  const base = (lastSpace > max * 0.6 ? cut.slice(0, lastSpace) : cut).replace(/[\s,;:—–-]+$/, "");
  return `${base}…`;
}

/** Meta description trimmed to a whole word within the render limit. */
export function seoDescription(text: string, max: number = MAX_DESCRIPTION): string {
  return clampAtWord(text, max);
}

/** Page title trimmed to a whole word within the render limit. */
export function seoTitle(text: string, max: number = MAX_TITLE): string {
  return clampAtWord(text, max);
}

/**
 * Append a brand suffix only when the combined title still fits, otherwise
 * return the bare title (never a truncated brand).
 */
export function titleWithSuffix(title: string, suffix: string, max: number = MAX_TITLE): string {
  const full = `${title} ${suffix}`.replace(/\s+/g, " ").trim();
  return full.length <= max ? full : seoTitle(title, max);
}
